module.exports = __webpack_public_path__ + "images/icons_v2/pin-outlined-c6abe545.svg";